import { AbstractChannelBoxService, ChannelModel, FilterGetChannels } from '@aionzdev/modules';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CatalogosApiService } from './api/catalogos-api.service';

@Injectable({ providedIn: 'root' })
export class ChannelBoxService extends AbstractChannelBoxService {
  private readonly _api = inject(CatalogosApiService);

  override getAllChannel(params: {
    takePage: number;
    currentPage: number;
    search?: string;
    filters?: FilterGetChannels;
  }): Observable<ChannelModel[]> {
    return this._api.findAllCanais({
      take: params.takePage,
      currentPage: params.currentPage,
      isOfficial: params.filters?.isOfficial
    });
  }
}
